import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const LEFT_RIGHT_PANEL_REVEAL_ACTIVITY_FRAGMENT = gql `
  fragment LeftRightPanelRevealActivityFragment on LeftRightPanelRevealActivity {
    rounds {
      answerImage {
        image {
          ...AssetFragment
        }
      }
      steps {
        column
        answer
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default LEFT_RIGHT_PANEL_REVEAL_ACTIVITY_FRAGMENT;
